import { CopyButton as MantineCopyButton } from '@mantine/core';

import type { IconNames } from '../Icon';
import { IconButton } from './index';

type CopyButtonTypes = 'item' | 'link' | 'copy';

const CopyButtonIconMap: Record<CopyButtonTypes, IconNames> = {
	item: 'clipboard',
	link: 'link',
	copy: 'copy',
};

interface CopyButtonProps {
	value: string;
	type?: CopyButtonTypes;
	timeout?: number;
	id?: string;
	disabled?: boolean;
}

function CopyButton({
	value,
	type = 'item',
	timeout,
	id,
	disabled = false,
}: CopyButtonProps) {
	return (
		<MantineCopyButton value={value} timeout={timeout}>
			{({ copied, copy }) => (
				<IconButton
					id={id}
					variant="tertiary"
					iconName={copied ? 'check' : CopyButtonIconMap[type]}
					onClick={copy}
					disabled={disabled}
					tooltip={copied ? 'Copied' : 'Copy'}
				/>
			)}
		</MantineCopyButton>
	);
}

export default CopyButton;
